import store from '../store';
import APIService from './APIService';
import config from '../../config';

/** Sync Service
 *
 */

// sync url from service
const syncServiceListenerUrl = config.baseUrlForSyncListenerService;
const syncServiceConsumerUrl = config.baseUrlForSyncConsumerService;
const mailSyncServiceConsumerUrl = config.baseUrlForMailSyncConsumerService;
// const AWSJobStatusUrl = config.baseUrlForAWSJobStatus;
export default class SyncService extends APIService {
  /**
   *
   * @param {Object} param0 { consumerType , orgId }
   * It takes two optional params :-
   *
   * @param consumerType set default to o365_group
   * @param orgId for organisation which is optional only in case you want it to be hardcode for any service
   * otherwise it takes currentlySelectedOrgId from store
   *
   */
  static syncNow({ consumerType = 'o365_group', orgId }) {
    // we have set it to default as of now
    const serviceUrl = consumerType === 'o365_group' ? syncServiceListenerUrl : mailSyncServiceConsumerUrl;
    let selectedOrgId = orgId ? orgId : store.state.currentlySelectedOrgId;
    const url = `${serviceUrl}/${selectedOrgId}/${consumerType}`;
    return this.get(url);
  }

  /**
   *
   * @param {String} orgId
   */
  static syncStatus(orgId = store.state.currentlySelectedOrgId) {
    const url = `${syncServiceConsumerUrl}/onboard/job/status/${orgId}`;
    return this.get(url);
  }
}
